// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"b0f12201","357":"0260ca0f","393":"23094baa","494":"163b8ccb","632":"68cc9130","643":"0d1a9e52","771":"8bcef49c"}[chunkId] + ".chunk.js";
};